import { axios } from "../../../lib/axios";

export const getHCNAuthorityList = (orgId) => {
  return axios.get(`/organization/${orgId}/hcn-authority`);
};

export const deleteHCNAuthority = (hcnId, orgId) => {
  return axios.delete(`/organization/${orgId}/hcn-authority/${hcnId}`);
};

export const createHCNAuthority = (orgId, payload) => {
  return axios.post(`/organization/${orgId}/hcn-authority`, payload);
};

export const getHCNAuthorityById = (orgId, hcnId) => {
  return axios.get(`/organization/${orgId}/hcn-authority/${hcnId}`);
};

export const editHCNAuthority = (orgId, hcnId, payload) => {
  return axios.put(`/organization/${orgId}/hcn-authority/${hcnId}`, payload);
};
